package io.github.jangalinski.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initAboutPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("about.md", FrontMatterElement.Builder { addScalar("title", "About"); addScalar("description", "This is what I do."); addScalar("header-img", "/img/about-bg.jpg"); }))
}

@Page("/about")
@Layout(".site.components.layout.BlogLayout")
@Composable
fun AboutPage() {
    org.jetbrains.compose.web.dom.H2(attrs = { id("who-am-i") }) {
        org.jetbrains.compose.web.dom.Text("Who am I")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/jangalinski") {
                    org.jetbrains.compose.web.dom.Text("jangalinski@github")
                }
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Text("I am fairly active on ")
                com.varabyte.kobweb.silk.components.navigation.Link("http://stackoverflow.com/users/290425/jan-galinski") {
                    org.jetbrains.compose.web.dom.Text("stackoverflow")
                }
                org.jetbrains.compose.web.dom.Text(".")
            }
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("technology-used-for-this-blog") }) {
        org.jetbrains.compose.web.dom.Text("Technology used for this blog")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("After many (unsuccesful) tries to come up with a regular tech/java based blog (I used wordpress, dokuwiki/blog, blogspot, ...) I finally ended up to have a jekyll/github setup. I can just write simple markdown files and push them to my repo and I am done. Works for me. There is still a lot of work to do (see my ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/jangalinski/jangalinski.github.io/issues/") {
            org.jetbrains.compose.web.dom.Text("issues")
        }
        org.jetbrains.compose.web.dom.Text(", and provide new ones if you find something that bothers you).")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://help.github.com/articles/using-jekyll-with-pages/") {
                org.jetbrains.compose.web.dom.Text("Jekyll on github pages")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/IronSummitMedia/startbootstrap-clean-blog-jekyll") {
                org.jetbrains.compose.web.dom.Text("Clean Blog Theme for Bootstrap and Jekyll")
            }
        }
    }
}
